// app/RootNotFoundClient.tsx   ← Keep 'use client'
'use client';

import { routing } from '@/i18n/routing';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import styles from './nofound.module.css';
// import ToolbarIcons from '@/icons/toolbar';
import GeneralContent from '@/components/structure/GeneralContent';
import config from '@/api/global';
import getFontByLocale from '@/functions/getFontByLocale';
import Toolbar from '@/components/structure/Toolbar';
import { LayoutProvider } from '@/context/LayoutContext';
import NotFoundContent from './NotFoundContent';
import NotFoundFooter from './NotFoundFooter';
import PageWrapper from '@/components/general/PageWrapper';

// import SingleCategory from '@/components/structure/Menu/CategoriesBox/SingleCategory';

export default function RootNotFoundClient() {
  const pathname = usePathname();
  const router = useRouter();
  const [messages, setMessages] = useState<{ common?: { notFound: string; returnHome: string } }>(
    {},
  );
  const deafaultLocale = 'fa';
  const [localeValue, setLocaleValue] = useState(deafaultLocale);
  const [categoryList, setCategoryList] = useState<any[]>([]);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, [router]);

  useEffect(() => {
    console.log('pathname==', pathname);
    const segments = pathname.split('/').filter(Boolean);
    const supportedLocales = routing?.locales || [deafaultLocale];
    const locale =
      segments[0] && supportedLocales.includes(segments[0]) ? segments[0] : deafaultLocale;
    setLocaleValue(locale);

    import(`@/messages/${locale}/general.json`)
      .then((mod) => setMessages(mod.default))
      .catch((err) => console.error('failed to load locale messages:', err));

    document.body.style.margin = '0px';
    document.documentElement.style.width = '100%';
    document.documentElement.style.height = '100%';
    document.body.style.width = '100%';
    document.body.style.height = '100%';
  }, [pathname]);

  const fontClass = getFontByLocale(localeValue);

  console.log('messages==', messages);

  return (
    <html>
      <body>
        <div
          className={`${styles.backWrapper} ${visible ? styles.fadeIn : styles.fadeOut} ${styles.uilayoutWrapper}  ${fontClass} ${config.isRTL(localeValue) ? styles.rtl : styles.ltr} uilayoutWrapper`}
        >
          <PageWrapper className={`${styles.pageWrapper}`}>
            <div className={`${styles.container}`}>
              <GeneralContent
                locale={localeValue}
                messages={messages}
                page={false}
                dir={config.isRTL(localeValue) ? styles.rtl : styles.ltr}
                className={`${styles.wrapperContent}`}
              >
                <LayoutProvider>
                  <Toolbar locale={localeValue} innerClass={styles.container} page="404" />
                  <NotFoundContent locale={localeValue} messages={messages} />
                  {/* <NotFoundFooter locale={localeValue} messages={messages} /> */}
                </LayoutProvider>
              </GeneralContent>
            </div>
          </PageWrapper>
        </div>
      </body>
    </html>
  );
}
